export const BANK_OPTIONS = [
  { label: "Хаан банк", value: "KHAAN_BANK" },
  { label: "Голомт банк", value: "GOLOMT_BANK" },
  { label: "Хас банк", value: "XAC_BANK" },
  { label: "Төрийн банк", value: "STATE_BANK" },
  { label: "Капитрон банк", value: "CAPITRON_BANK" },
  { label: "Худалдаа хөгжлийн банк", value: "TRADE_AND_DEVELOPMENT_BANK" },
  { label: "Ариг банк", value: "ARIG_BANK" },
  { label: "Тээвэр хөгжлийн банк", value: "TRANS_BANK" },
  { label: "Богд банк", value: "BOGD_BANK" },
];

export function getBankLabel(value) {
  const found = BANK_OPTIONS.find((item) => item.value === value);
  return found?.label || value || "-";
}